import { REPAYMENT_ROWS } from "./grantProgramData";

export default function RepaymentTypeTable() {
  return (
    <div className="overflow-x-auto rounded-xl border border-border">
      <table className="w-full min-w-[720px] text-left text-sm">
        <caption className="sr-only">
          True grant versus forgivable loan versus deferred loan versus lender credit
        </caption>
        <thead className="bg-muted/60">
          <tr>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">What it's called</th>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">What it actually is</th>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">Do you pay it back?</th>
            <th scope="col" className="px-4 py-3 font-bold text-foreground">What to watch for</th>
          </tr>
        </thead>
        <tbody>
          {REPAYMENT_ROWS.map((r) => (
            <tr key={r.label} className="border-t border-border align-top">
              <th scope="row" className="px-4 py-3 font-semibold text-foreground">{r.label}</th>
              <td className="px-4 py-3 text-muted-foreground">{r.plain}</td>
              <td className="px-4 py-3 font-medium text-foreground">{r.payBack}</td>
              <td className="px-4 py-3 text-muted-foreground">{r.watchFor}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}